<template>
  <div class="docuforms">
    <MatterPageList :list="items" class="docuforms__list" data-testid="docuforms__list">
      <template v-slot:list-prview="{ item }">
        <DocuformsItem
          :item="item"
          :showType="false"/>
      </template>
    </MatterPageList>
    <InfiniteScroll
      @on-scroll="loadMore"
      :identifier="refreshId"
      :is-empty="isEmpty"
      :no-result-txt="$t('client.matters.matter_page.docuforms_tab.empty_state_indicator')" />
  </div>
</template>

<script>
import DocuformsItem from './DocuformsItem'
import {InfiniteScroll} from "@/modules/common/components"
import MatterPageList from '@/modules/matters/components/matterPageList/MatterPageList'
import {mapGetters} from "vuex";

export default {
  name: "DocuformsList",
  components: {
    DocuformsItem,
    MatterPageList,
    InfiniteScroll
  },
  props: {
    initiator: {
      type: String,
      required: true
    },
    refreshId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters("mattersModule", ["currContact"]),
    capitalizedInitiator() {
      return this.$options.filters.capitalize(this.initiator);
    },
    setPage() {
      return `mattersModule/set${this.capitalizedInitiator}DocuformsPage`;
    },
    items() {
      return this.$store.getters[`mattersModule/${this.initiator}Docuforms`]
    },
    currPage() {
      return this.$store.getters[`mattersModule/${this.initiator}DocuformsPage`];
    },
    isCompleted() {
      return this.$store.getters[`mattersModule/${this.initiator}DocuformsCompleted`];
    },
    isEmpty() {
      return this.isCompleted && !this.items.length
    }
  },
  methods: {
    async loadMore($state) {
      this.$store.commit(this.setPage, this.currPage + 1);
      await this.$store.dispatch({type: `mattersModule/loadDocuforms`, payload: {initiator: this.initiator}});

      if (this.isCompleted) {
        $state.complete();
        return;
      }

      $state.loaded();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_i18n-mixins';

.docuforms {

  .matter-page-list .matter-page-list-item {
    padding: 0;
  }

  &__list {
    padding: 0 15px;

    @media only screen and (min-width: 768px) {
      padding-inline-start: 24px;
    }
  }
}
</style>
